import request from '@/utils/request'

// 获取收货地址列表
export const getReceivedAddressListApi = () => {
  return request.get('/address/list')
}

// 获取省市区-以便接下来添加地址
export const getAddressSourceApi = () => {
  return request.get('/region/tree')
}

// 添加地址
export const addAddressApi = ({ name, phone, region, detail }) => {
  return request.post('/address/add', {
    form: {
      name,
      phone,
      region,
      detail
    }
  })
}

// 获取收货地址详情
export const getReceivedDetailApi = (addressId) => {
  return request.get('/address/detail', {
    params: {
      addressId
    }
  })
}

// 编辑收货地址
export const EditReceivedDetailApi = (addressId, obj) => {
  return request.post('/address/edit', {
    addressId,
    form: obj
  })
}

// 删除地址
export const deleteAddressAPi = (addressId) => {
  return request.post('/address/remove', {
    addressId
  })
}
// 设置默认地址
export const setDefaultAddressApi = (addressId) => {
  return request.post('/address/setDefault', {
    addressId
  })
}

// 获取默认地址
export const getDefaultAddressApi = () => {
  return request.get('/address/defaultId')
}
